// src/components/EventCard.js

import React from 'react';

const EventCard = ({ event }) => {
  return (
    <div className="card h-100 shadow-sm border-0 rounded-4 overflow-hidden" style={{ transition: 'transform 0.2s ease-in-out' }}>
      
      {/* Poster Alanı - Güncellendi */}
      <div style={{ height: '300px', backgroundColor: '#fcfcfc', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img 
          src={event.posterUrl} 
          alt={event.name} 
          style={{ width: '100%', height: '100%', objectFit: 'contain', padding: '15px' }} 
        />
      </div>
      
      {/* Kart İçeriği */}
      <div className="card-body d-flex flex-column p-4">
        <h5 className="card-title fw-bold mb-3" style={{ color: "#1a365d" }}>
          {event.name}
        </h5>
        
        <div className="text-muted small mb-4">
          <div className="d-flex align-items-center mb-2">
            <span className="me-2">📅</span> {event.date} {event.time && `- ${event.time}`}
          </div>
          <div className="d-flex align-items-start">
            <span className="me-2">📍</span> {event.location}
          </div>
        </div>
        
        {/* Details Butonu */}
        <div className="mt-auto border-top pt-3">
          <div className="d-flex align-items-center justify-content-between text-primary fw-bold" style={{ cursor: 'pointer' }}>
            <span>Details</span>
            <span>→</span>
          </div>
        </div>
      </div>

    </div>
  );
};

export default EventCard;